import { TPayPackageGift } from '../../../../PayPackageMicrofrontend';
import { EServiceType } from '../publishTerms';
import { TRecommendedPackageGift } from './gifts';

export interface IRecommendedPackageService {
  /** Тип услуги */
  serviceType: EServiceType;
  /** Название услуги */
  name: string;
  /** Количество объявлений */
  count: number;
  /** Срок действия */
  durationInDays: number;
  /** Количество бонусов */
  auctionPoints: number;
  /** Цена */
  price: number;
}

export interface IRecommendedPackage {
  /**
   * Является индексом при поиске выбранного пакета.
   * packageId не может быть индексом, так как среди пакетов с бэка
   * могут быть кастомные пакеты без id и их может быть несколько.
   */
  id: string;
  /** id пакета, нужен бэку при покупке */
  packageId?: number;
  /** автопролонгация */
  autoProlong: boolean;
  /** Текст заголовка блока рекомендованного пакета */
  headerText: string;
  /** текст хинта блока рекомендованного пакета */
  tooltipText: string;
  /** Длительность пакета в днях */
  durationInDays: number;
  /** Названия регионов действия рекомендованного пакета */
  regionNames: string[];
  /** Название категории в карточке рекомендованного пакета */
  categoriesView: string;
  /** Цена рекомендованного пакета */
  price: number;
  /** Скидка на рекомендованного пакет */
  discountPercent: number;
  /** Цена без скидки */
  marketingPrice: number;
  /** Цена за одно объявление с учетом скидки */
  pricePerOffer: number;
  /** Дата начала действия рекомендованного пакета */
  packageStartDate: string;
  /** Дата окончания действия рекомендованного пакета */
  packageEndDate: string;
  /** Общее количество объявлений в рекомендованном пакете */
  totalPublicationCount: number;
  /** Общее количество бонусов в рекомендованном пакете */
  totalAuctionPoints: number;
  /** Признак выбора пакета */
  selected: boolean;
  /** Сервисы в рекомендованном пакете */
  services: IRecommendedPackageService[];
  /** Тип пакета */
  type: EPackageType;
  /** Полигоны пакета */
  polygonIds: number[];
  /** ID категорий для кастомного пакета */
  categoriesIds: Array<number>;
  publishType: ERecommendedPackagePublishType;
  /** Тип рекомендуемого пакета */
  packageType: ERecommendedPackageType;
  /** Подарки */
  gifts: Array<TRecommendedPackageGift>;
}

export type TSelectedRecommendedPackageId = string | null;

export interface IRecommendedPackageCheckoutModalDataService extends IRecommendedPackageService {
  name: string;
}

export interface IRecommendedPackageCheckoutModalData {
  packageId?: number | string;
  autoprolong: boolean;
  marketingPrice: number;
  discountPercent: number;
  price: number;
  durationInDays: number;
  regions: string[];
  category: string;
  startDate: string;
  endDate: string;
  polygonIds: number[];
  totalAuctionPoints: number;
  services: IRecommendedPackageCheckoutModalDataService[];
  widgetSource?: EBuyPackageSource;
  gifts: TPayPackageGift[];
}

export interface IRecommendedPackagesState {
  selectedPackageId: TSelectedRecommendedPackageId;
  packages: IRecommendedPackage[];
  isFillBalance: boolean;
  checkoutModalData: IRecommendedPackageCheckoutModalData;
}

export enum EPackageType {
  /** Общее предложение (Быстрая сделка, Vip-пакет) **/
  CommonOffer = 'commonOffer',
  /** Специальное предложение - сгенерировано на основе промокода **/
  SpecialOffer = 'specialOffer',
  /** Персональное предложение - будет генерироваться на отдельных условиях **/
  PersonalOffer = 'personalOffer',
  /** Общее предложение - подписки на публикации **/
  CommonSubscription = 'commonSubscription',
  /** Смарт-пакет **/
  SmartPackage = 'smartPackage',
  /** Пакет "Всё включено" */
  AllIn = 'allIn',
  /** Подписка */
  Subscription = 'subscription',
}

export enum ERecommendedPackageType {
  AllIn = 'allIn',
  Smb = 'smb',
  Custom = 'custom',
}

export enum EBuyPackageSource {
  LK = 'lk',
  AddForm = 'addForm',
  ServicePackageAdmin = 'servicePackageAdmin',
  SubscriptionAdmin = 'subscriptionAdmin',
  Mobile = 'mobile',
  Promocodes = 'promocodes',
  SmartPack = 'smartpack',
  AllIn = 'allIn',
  AddFormAllIn = 'addFormAllIn',
  AddFormSmartPack = 'addFormSmartPack',
}

export enum ERecommendedPackagePublishType {
  /** Слоты - переиспользуемые слоты в рамках срока действия пакета */
  Slot = 'slot',
  /** Публикации - ограниченное количество публикаций объявлений за счёт пакета */
  Publication = 'publication',
}
